import * as Yup from 'yup'

import { PaymentMethod } from 'src/types/purchase'

import { DonateFrequencyTab } from './types'

export enum MessageType {
  Anonymous = 'Anonymous',
  Public = 'Public',
  None = 'None'
}

export const invoiceAddressSchema = Yup.object({
  InvoiceAddress0: Yup.string(),
  InvoiceAddress1: Yup.string().optional(),
  InvoiceCity: Yup.string(),
  InvoiceCountry: Yup.string(),
  InvoicePostCode: Yup.string()
}).required()

export const treeStepSchema = Yup.object().shape({
  Amount: Yup.string().required(),
  PricePerTree: Yup.string().required(),
  RegistryId: Yup.string(),
  PlantingRegionId: Yup.string(),
  Quantity: Yup.string().required(),
  QuantityOther: Yup.string().when('Quantity', {
    is: (val: string | undefined) => val === 'other',
    then: Yup.string()
      .required('Please enter the number of trees to donate')
      .test(
        'min',
        'Please enter one or more trees to donate',
        (value: string | undefined) => (value ? parseInt(value) > 0 : false)
      )
  }),
  PublicName: Yup.string().when('UserEventMessageType', {
    is: (messageType: MessageType) => {
      return messageType === MessageType.Public
    },
    then: Yup.string().required('Name to display is required'),
    otherwise: Yup.string().optional().default('')
  }),
  PublicMessage: Yup.string().when('UserEventMessageType', {
    is: (messageType: MessageType) => {
      return (
        messageType === MessageType.Public ||
        messageType === MessageType.Anonymous
      )
    },
    then: Yup.string().required('Message is required'),
    otherwise: Yup.string().optional().default('')
  }),
  UserEventMessageType: Yup.string().oneOf(Object.values(MessageType)),
  DonationType: Yup.string().oneOf(Object.values(DonateFrequencyTab)).required()
})

export const paymentStepSchema = Yup.object().shape({
  PaymentMethod: Yup.string().required('Please select a payment method'),
  SavePaymentMethod: Yup.boolean().optional().default(false),
  InvoiceAddress: Yup.object({}).when('PaymentMethod', pm => {
    if (pm === PaymentMethod.Invoice) {
      return Yup.object({
        InvoiceAddress0: Yup.string().required('Address line 1 is required'),
        InvoiceAddress1: Yup.string().optional(),
        InvoiceCity: Yup.string().required('City is required'),
        InvoiceCountry: Yup.string().required('Country is required'),
        InvoicePostCode: Yup.string().required('Post code is required')
      })
    }
    return Yup.object({
      InvoiceAddress0: Yup.string(),
      InvoiceAddress1: Yup.string().optional(),
      InvoiceCity: Yup.string(),
      InvoiceCountry: Yup.string(),
      InvoicePostCode: Yup.string()
    })
  }),
  ReceiptEmail: Yup.string()
    .email('Please enter a valid email address')
    .required('Please enter an email address'),
  ReceiptName: Yup.string().required('Please enter a name for your receipt'),
  Organisation: Yup.string().optional().default(''),
  CommsOptIn: Yup.boolean().optional().default(false)
})
